import { types } from "../types/types";
const intitalState = {
    userProfile: {},
    keyList: [],
};

const profileReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.USER_DETAIL:
            return {
                ...state,
                userProfile: action.payload,
            };
        case types.SET_KEY_LIST:
            return {
                ...state,
                keyList: Array.isArray(action.payload) ? action.payload : [],
            };
        default:
            return { ...state };
    }
};

export default profileReducer;
